import { Flex, Text } from '@chakra-ui/react'
import { ResumoCubagem } from '../ResumoCubagem'
import { useKanguCargobr } from '../../../../../contexts/KanguCargobrContext'

export function Cubagem({ isAgrupped, infoAgrupped, proximaCaixa }) {
  const { cubagens } = useKanguCargobr()

  const novaCubagens = cubagens.reduce((acc, item) => {
    const { medida, quantidade_caixas } = item

    // Verifica se já existe uma medida igual no novo array
    const medidaExistente = acc.find((cubagem) => cubagem.medida === medida)

    if (medidaExistente) {
      // Se a medida já existe, soma a quantidade de caixas, antes de somar transforma ambos em Number
      medidaExistente.quantidade_caixas =
        Number(medidaExistente.quantidade_caixas) + Number(quantidade_caixas)
    } else {
      // Se a medida não existe, adiciona uma nova entrada no novo array
      acc.push({ medida, quantidade_caixas })
    }

    return acc
  }, [])

  console.log('novaCubagens', novaCubagens)

  return (
    <>
      <Flex w="100%" flexDir="column" mt="1rem" gap={3}>
        <Text
          as="h1"
          m="0"
          fontSize="1rem"
          textTransform="uppercase"
          textAlign="center"
          bg="#e9e9e9"
          paddingBlock=".6rem"
        >
          Cubagem total
        </Text>
        <Flex
          w="100%"
          gap={3}
          paddingInline="1rem"
          border="1px solid #cecece"
          paddingBlock="1rem"
          justifyContent={'space-between'}
        >
          <Flex flexDir="column">
            {novaCubagens?.map((item, index) => {
              return (
                <Text as="span" m="0" fontSize="1rem" textAlign="start">
                  Caixa:{' '}
                  <Text as="span" fontWeight={'bold'}>
                    {' '}
                    {item.medida}
                  </Text>{' '}
                  Qnt:{' '}
                  <Text as="span" fontWeight={'bold'}>
                    {item.quantidade_caixas} unidades
                  </Text>
                </Text>
              )
            })}
          </Flex>
        </Flex>
      </Flex>
      {
        <ResumoCubagem
          isAgrupped={isAgrupped}
          infoAgrupped={infoAgrupped}
          proximaCaixa={proximaCaixa}
        />
      }
    </>
  )
}
